import React, { Component } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { InputAdornment } from "@mui/material";
import Button from "@material-ui/core/Button";
import { Buffer } from "buffer";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import Pagination from "../pagination/Pagination";
import _ from "lodash";
import PtsAlert from "../ptsAlert/PtsAlert";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class TextResponseDialog extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  paginationState = store.getState().paginations.textResponseMsgStatsState;

  constructor(props) {
    super(props);
    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }
    this.state = {
      message: null,
      textResponseMessageList: [],
      messageName: "",
      initialPage: 0,
      pageSize:
        this.paginationStateDetails?.length > 0
          ? this.paginationState?.pageSize
          : 10,
      sortColumn: this.paginationStateDetails?.length > 0
        ? this.paginationState?.sortColumn : null,
      isAscSort: this.paginationStateDetails?.length > 0
        ? this.paginationState?.isAscSort : false,
      sortDirection: "asc",
      open: false,
    };
    this.debouncedSearch = _.debounce(this.showTextResponseList, 800);
  }

  showTextResponseList(message, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      smsMessage: { id: message?.id },
      eventid: this.businessDomainId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(
      "/smsmessagems/getMessageIncomingData",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let textResponseMessageList = output.data.recordList;
        let page = output.data.page;
        for (let i = 0; i < textResponseMessageList.length; i++) {
          textResponseMessageList[i].contactMobile =
            Utils.viewTollFreeNumberFormate(
              textResponseMessageList[i].contactMobile
            );
          textResponseMessageList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(textResponseMessageList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
            textResponseMessageList[i].createdOn, true
          );
        }

        this.setState({
          render: true,
          message: message,
          textResponseMessageList: textResponseMessageList,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
          open: true,
        });
      } else {
      }
    });
  }
  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.message,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const textResponseMsgStatsState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.textResponseMsgStatsPaginationState({ textResponseMsgStatsState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
    });
    this.showTextResponseList(this.state.message, currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort,);
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  // handleSort(column) {
  //   const { sortColumn, sortDirection, textResponseMessageList } = this.state;
  //   let newDirection = "asc";

  //   if (sortColumn === column && sortDirection === "asc") {
  //     newDirection = "desc";
  //   }

  //   this.setState({
  //     textResponseMessageList: Utils.sortList(
  //       textResponseMessageList,
  //       column,
  //       newDirection
  //     ),
  //     sortColumn: column,
  //     sortDirection: newDirection,
  //   });
  // }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const textResponseMsgStatsState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.textResponseMsgStatsPaginationState({ textResponseMsgStatsState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
      },
      () => {
        this.showTextResponseList(
          this.state.message,
          pageNo,
          pageSize,
          column,
          isAscSort
        );
      }
    );
  }

  exportMessageData(data) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: this.state.message?.id,
      },
    };

    FetchServerData.callPostService(
      "/csvImpExpms/exportMessageIncomingHistoryData",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let csvMessageData = output.data;
          const byteArray = new Buffer(
            csvMessageData.data.replace(/^.+base64,/, ""),
            "base64"
          );
          const outputFilename = csvMessageData.filename;
          const url = URL.createObjectURL(new Blob([byteArray]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();
        } else {
        }
      })
      .catch((error) => { });
  }

  render() {
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="activityDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Text Response Message History</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent className="p-4">
            <div className="row">
              <div className="col">
                <div className="col md-12">
                  <div className="card rounded-0">
                    <div className="row justify-content-between p-2">
                      <div className="d-flex col-12 col-lg-5 col-xl-5">
                        <div className="col-12 text-start totalResults">
                          <span style={{ fontSize: "12px" }}>
                            Text Response: {this.state.totalRecords}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                        <div className="row d-flex">
                          <div className="col-sm-6 align-self-end text-end">
                            <Button
                              id="downloadReportButton"
                              variant="contained"
                              type="button"
                              startIcon={
                                <i
                                  className="fa fa-download"
                                  style={{ fontSize: "16px" }}
                                ></i>
                              }
                              onClick={this.exportMessageData.bind(this)}
                              className="me-3"
                            >
                              Download Report
                            </Button>
                          </div>
                          <div className="col-sm-6">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.showTextResponseList.bind(
                                        this,
                                        this.state.message,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState(
                                          { searchText: "" },
                                          () => {
                                            this.showTextResponseList(
                                              this.state.message,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            );
                                          }
                                        );
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive hfmPaginationTable">
                      <table
                        className="table text-start table-hover"
                        style={{ fontSize: "12px" }}
                      >
                        <thead className="hfmPaginationTableThead">
                          <tr>
                            <th scope="col fw-bold">Mobile Number</th>
                            <th
                              scope="col fw-bold"
                              onClick={() =>
                                this.handleSort("contactFirstName")
                              }
                            >
                              First Name
                              {this.state.sortColumn === "contactFirstName" &&
                                (this.state.sortDirection === "asc" ? (
                                  <i
                                    class="fa fa-long-arrow-up ps-1"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                ))}
                            </th>
                            <th
                              scope="col fw-bold"
                              onClick={() => this.handleSort("contactLastName")}
                            >
                              Last Name
                              {this.state.sortColumn === "contactLastName" &&
                                (this.state.sortDirection === "asc" ? (
                                  <i
                                    class="fa fa-long-arrow-up ps-1"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                ))}
                            </th>
                            <th
                              scope="col fw-bold"
                              onClick={() => this.handleSort("contactEmail")}
                            >
                              Email
                              {this.state.sortColumn === "contactEmail" &&
                                (this.state.sortDirection === "asc" ? (
                                  <i
                                    class="fa fa-long-arrow-up ps-1"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                ))}
                            </th>

                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSort("messageText")}
                            >
                              Reply
                              {this.state.sortColumn === "messageText" &&
                                (this.state.sortDirection === "asc" ? (
                                  <i
                                    class="fa fa-long-arrow-up ps-1"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                ))}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.textResponseMessageList?.map(
                            (rowData, index) => (
                              <tr key={index}>
                                <td style={{ width: "190px" }}>
                                  {rowData.contactMobile}
                                </td>
                                <td style={{ width: "140px" }}>
                                  {rowData.contactFirstName}
                                </td>
                                <td style={{ width: "140px" }}>
                                  {rowData.contactLastName}
                                </td>
                                <td style={{ width: "200px" }}>
                                  {rowData.contactEmail}
                                </td>

                                <td style={{ width: "250px" }}>
                                  {rowData.messageText}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div
                        className="row text-center"
                        style={{ padding: "6px 20px" }}
                      >
                        <h5 className="dataNotAvailable">No data found.</h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-1">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="pageSize col-12 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default TextResponseDialog;
